import { BaseDto } from 'src/dtos/common/baseDto';

export interface TqcGaugeCalibPlanDto extends BaseDto {
	equipmentCd: string;
	compCd: string;
	planYear: string;
	month01: string;
	month02: string;
	month03: string;
	month04: string;
	month05: string;
	month06: string;
	month07: string;
	month08: string;
	month09: string;
	month10: string;
	month11: string;
	month12: string;
	remark: string;
	inserted?: boolean;
	isModified?: boolean;
}

export const defaultTqcGaugeCalibPlanDto: TqcGaugeCalibPlanDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,
	equipmentCd: '',
	compCd: '',
	planYear: '',
	month01: '',
	month02: '',
	month03: '',
	month04: '',
	month05: '',
	month06: '',
	month07: '',
	month08: '',
	month09: '',
	month10: '',
	month11: '',
	month12: '',
	remark: '',
	inserted: false,
	isModified: false,
};
